<template>
    <b-modal
            id="no-parts-required-modal"
            no-footer
            title="No parts required">

        <!-- Header close button -->
        <template v-slot:modal-header-close>
            <span @click="closeModal">×</span>
        </template>

        <empty-state
                statusIcon="warning"
                statusIconSize="4x"
                title="Are you sure no parts are required?"
                subtitle="Please ensure you only confirm no parts are required when applicable, as this may have an affect on your KPIs">
        </empty-state>
        <div class="form-group">
            <label>Please add a note</label>
            <textarea class="form-control" rows="6" placeholder="Required" v-model="newNoteText"></textarea>
        </div>

        <template v-slot:modal-footer>
            <button type="button" class="btn btn-light" @click="closeModal">Cancel</button>
            <button type="button" class="btn btn-danger" @click="confirmNoParts()" :disabled="!newNoteText">No parts required</button>
        </template>
    </b-modal>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        props:['jobId', 'deviceId'],

        data() {
            return {
                newNoteText: ""
            }
        },

        computed: {
            ...mapGetters([
                "nextRepairStep",
                "user"
            ])
        },

        methods: {
            ...mapActions([
                "addDeviceNote",
                "setNoPartsRequired"
            ]),

            /** Close the modal */
            closeModal() {
                this.$bvModal.hide('no-parts-required-modal');
                this.$emit('close');
            },

            /** Confirm no parts required */
            confirmNoParts() {
                this.setNoPartsRequired({
                    jobId: this.jobId,
                    deviceId: this.deviceId
                }).then(() => {
                    this.addDeviceNote({
                        jobId: this.jobId,
                        deviceId: this.deviceId,
                        newNoteText: this.newNoteText,
                        user: this.user
                    }).then(() => {
                        this.newNoteText = "";
                        this.$bvModal.hide('no-parts-required-modal');
                        this.$router.push({ name: this.nextRepairStep(this.$route.name).routeName});
                    });
                });

            }
        }
    }
</script>

<style scoped>

</style>